var state = {
    state: 0,
    time: 0,
    duration: 0,
    buffered: 0,
    repeat: 0,
    shuffle: false,
    position: null,
    playlist: [],
    provider: "",
    alteringPlaylist: false,
};
var getters = {
    audio: function (state) {
        return state.playlist[state.position];
    }
};
var actions = {
    playAudio: function (_a, audio, playlist, position) {
        var commit = _a.commit, getters = _a.getters;
        if (playlist === void 0) { playlist = null; }
        if (position === void 0) { position = 0; }
        audio = JSON.parse(JSON.stringify(audio));
        if (playlist) {
            commit("SET_PLAYLIST", playlist.audios);
            commit("SET_POSITION", position);
        }
        else {
            if (!getters.audio || getters.audio.id !== audio.id) {
                commit("PLAYLIST_PUSH", audio);
                commit("SET_POSITION", state.playlist.length - 1);
            }
            else if (getters.audio && (getters.audio.id === audio.id)) {
                commit('SET_STATE', 1);
            }
        }
    },
    play: function (_a) {
        var commit = _a.commit;
        commit('SET_STATE', 1);
    },
    pause: function (_a) {
        var commit = _a.commit;
        commit('SET_STATE', 2);
    },
    setShuffle: function (_a, shuffle) {
        var commit = _a.commit;
        commit('SET_SHUFFLE', shuffle);
    },
    toggleShuffle: function (_a) {
        var commit = _a.commit;
        commit('TOGGLE_SHUFFLE');
    },
    setRepeat: function (_a, repeat) {
        var commit = _a.commit;
        commit('SET_REPEAT', repeat);
    },
    setState: function (_a, s) {
        var commit = _a.commit;
        commit('SET_STATE', s);
    },
    setPosition: function (_a, position) {
        var commit = _a.commit;
        commit('SET_POSITION', position);
    },
    setTime: function (_a, time) {
        var commit = _a.commit;
        commit('SET_TIME', time);
    },
    setDuration: function (_a, duration) {
        var commit = _a.commit;
        commit('SET_DURATION', duration);
    },
    setBuffered: function (_a, buffered) {
        var commit = _a.commit;
        commit('SET_BUFFERED', buffered);
    },
    setPlaylist: function (_a, playlist) {
        var commit = _a.commit;
        commit('SET_PLAYLIST', playlist);
    },
    setAlteringPlaylist: function (_a, val) {
        var commit = _a.commit;
        commit('SET_ALTERING_PLAYLIST', val);
    },
    playlistPull: function (_a, index) {
        var commit = _a.commit;
        commit('PLAYLIST_PULL', index);
    },
    playlistPush: function (_a, audio) {
        var commit = _a.commit;
        commit('PLAYLIST_PUSH', audio);
    },
};
var mutations = {
    SET_ALTERING_PLAYLIST: function (state, val) {
        state.alteringPlaylist = val;
    },
    SET_PLAYLIST: function (state, playlist) {
        state.playlist = playlist;
    },
    PLAYLIST_PUSH: function (state, audio) {
        state.playlist.push(audio);
        if (state.position === null) {
            state.position = 0;
        }
    },
    PLAYLIST_PULL: function (state, index) {
        state.playlist.splice(index, 1);
    },
    SET_POSITION: function (state, position) {
        state.position = position;
    },
    SET_TIME: function (state, time) {
        state.time = time;
    },
    SET_DURATION: function (state, duration) {
        state.duration = duration;
    },
    SET_BUFFERED: function (state, buffered) {
        state.buffered = buffered;
    },
    SET_STATE: function (state, newPlayerState) {
        state.state = newPlayerState;
    },
    SET_REPEAT: function (state, repeat) {
        state.repeat = repeat;
    },
    SET_SHUFFLE: function (state, shuffle) {
        state.shuffle = shuffle;
    },
    TOGGLE_SHUFFLE: function (state) {
        state.shuffle = !state.shuffle;
    },
};
export default {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};



//////////////////
// WEBPACK FOOTER
// ./src/store/modules/player.ts
// module id = 276
// module chunks = 0